// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D0Fzs","title":"styles_title__3OxpI"};